export const SDK_VERSION = '6.15.0';
